<app-loader *ngIf="!availableContractorTypes"></app-loader>
<form [formGroup]="subForm" (ngSubmit)="submit()" *ngIf="availableContractorTypes">
  <div class="switch">
    <label>
      <input type="checkbox" formControlName="allowNotListedOption" [(ngModel)]="dataEntity.allowNotListedOption" />
      Allow Not Listed Option
    </label>
  </div>
  <div class="switch">
    <label>
      <input type="checkbox" formControlName="allowRegisterRenewalOption"
        [(ngModel)]="dataEntity.allowRegisterRenewOption" />
      Allow Register/Renew
    </label>
  </div>
  <div *ngIf="availableContractorTypes.length > 0">
    <div class="form-check" *ngFor="
      let contractorType of availableContractorTypes;
      let i = index
    ">
      <label>
        <input type="checkbox" [checked]="isSelected(contractorType.id)"
          (change)="selectContractorType($event.target.checked, contractorType.id)" />
        {{ contractorType.name }}
      </label>
    </div>
  </div>
</form>
